module.exports = __webpack_public_path__ + "img/thumbnail_SaltwaterCrocodile_m_normal.87cb04de.png";